import type maplibregl from "maplibre-gl";
import type { StyleValue } from "../types";

type Props = {
	attribute: string;
	min: number;
	max: number;
	from: StyleValue;
	to: StyleValue;
	scale: "linear" | "log";
};

function buildInterpolateExpression({ attribute, min, max, from, to, scale }: Props): maplibregl.ExpressionSpecification {
	const value = ["to-number", ["coalesce", ["get", attribute], 0]];

	if (scale === "log") {
		const input = ["log10", ["max", 1, value]];
		const low = Math.log10(Math.max(1, min));
		const high = Math.log10(Math.max(2, max));

		return ["interpolate", ["linear"], input, low, from, high, to] as unknown as maplibregl.ExpressionSpecification;
	}

	// maplibre requires strictly ascending stops; guard a degenerate min === max range.
	const high = max > min ? max : min + 1;

	return ["interpolate", ["linear"], value, min, from, high, to] as unknown as maplibregl.ExpressionSpecification;
}

export { buildInterpolateExpression };
